import { Trans } from '@lingui/macro';
import * as React from 'react';

export const inputRequiredErrorMessage = <Trans>Ce champ est requis</Trans>;
